import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import I18n from 'PMT/i18n/I18n';

function FeatureNonActivatedPage(props) {
  return (
    <div className="top-buffer-50 text-center">
      <i className="icon-smiley-down" />
      <h1 className="text-center">
        {I18n.tr('feature_not_activated')}
      </h1>
    </div>
  );
}

export default FeatureNonActivatedPage;
